import {BuxPopoverController} from '@assets/bux-scripts/popover'

const $tooltipConfig = {
    queries: {
        /* How the init function finds the tooltip trigger */
        trigger: ".bux-tooltip__trigger", /* How the init function finds the tooltip body container */
        container: ".bux-tooltip__container",
    }
}

/**
 * A class to manage tooltip positioning via BuxPopoverController
 */
class BuxTooltipController extends BuxPopoverController {
    private hasMouseover: boolean;
    private hasFocus: boolean;

    constructor(triggerElement: HTMLElement, containerElement: HTMLElement) {
        /* BuxPopoverController takes care of toggling and positioning, and adds
        * the trigger, caret, and container elements to the class */
        super(triggerElement, containerElement);

        this.hasMouseover = false;
        this.hasFocus = false;

        this.trigger.element.addEventListener("mouseenter", this.expandFromMouseenter.bind(this));
        this.trigger.element.addEventListener("focus", this.expandFromFocus.bind(this));
        this.trigger.element.addEventListener("blur", this.maybeCollapseFromBlur.bind(this));
        this.trigger.element.addEventListener("mouseleave", this.maybeCollapseFromMouseleave.bind(this));
    }

    expandFromMouseenter() {
        this.hasMouseover = true;
        this.expand();
    }

    expandFromFocus() {
        this.hasFocus = true;
        this.expand();
    }

    maybeCollapseFromBlur() {
        this.hasFocus = false;
        if (!this.hasMouseover) {
            this.collapse();
        }
    }

    maybeCollapseFromMouseleave() {
        this.hasMouseover = false;
        if (!this.hasFocus) {
            this.collapse();
        }
    }

}

/**
 * Finds triggers, matches them with containers, and initializes controllers
 */
const initTooltips = () => [...document.querySelectorAll($tooltipConfig.queries.trigger)]
    .map((trigger) => {
        const container = trigger.querySelector($tooltipConfig.queries.container);
        if (!(trigger instanceof HTMLElement)) {
            console.warn("BUX Tooltip could not find a valid trigger of type HTMLElement");
            return;
        }
        if (!(container instanceof HTMLElement)) {
            console.warn(
                "BUX Tooltip could not find a valid container for a tooltip trigger. This is probably an issue with the page markup, and functionality will be impacted.");
            return;
        }
        return new BuxTooltipController(trigger, container);
    });

initTooltips();
